import "@/App.css";
import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Sidebar } from "@/components/Sidebar";
import { AuthProvider, useAuth } from "@/lib/auth";
import { ChangePasswordDialog } from "@/components/ChangePasswordDialog";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Leads from "@/pages/Leads";
import Clinics from "@/pages/Clinics";
import Finder from "@/pages/Finder";
import Pipeline from "@/pages/Pipeline";
import Templates from "@/pages/Templates";
import Activities from "@/pages/Activities";
import StageDefinitions from "@/pages/StageDefinitions";
import BDPerformance from "@/pages/BDPerformance";

const ProtectedShell = ({ children }) => {
  const { user, loading, refresh } = useAuth();
  const [mustChangeOpen, setMustChangeOpen] = useState(false);

  useEffect(() => {
    if (user?.must_change_password) setMustChangeOpen(true);
  }, [user]);

  if (loading) return <div className="min-h-screen flex items-center justify-center font-mono text-xs uppercase tracking-wider text-[#5C5E66]">LOADING...</div>;
  if (!user) return <Navigate to="/login" replace />;

  return (
    <div className="flex">
      <Sidebar />
      <main className="flex-1 min-h-screen">{children}</main>
      <ChangePasswordDialog
        open={mustChangeOpen}
        onOpenChange={(o) => { setMustChangeOpen(o); if (!o) refresh(); }}
        mustChange={user.must_change_password}
      />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<ProtectedShell><Dashboard /></ProtectedShell>} />
            <Route path="/leads" element={<ProtectedShell><Leads /></ProtectedShell>} />
            <Route path="/clinics" element={<ProtectedShell><Clinics /></ProtectedShell>} />
            <Route path="/finder" element={<ProtectedShell><Finder /></ProtectedShell>} />
            <Route path="/pipeline" element={<ProtectedShell><Pipeline /></ProtectedShell>} />
            <Route path="/activities" element={<ProtectedShell><Activities /></ProtectedShell>} />
            <Route path="/performance" element={<ProtectedShell><BDPerformance /></ProtectedShell>} />
            <Route path="/stages" element={<ProtectedShell><StageDefinitions /></ProtectedShell>} />
            <Route path="/templates" element={<ProtectedShell><Templates /></ProtectedShell>} />
          </Routes>
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
